var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMsDynamicsIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 0 256 256"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "#13224d",
  strokeMiterlimit: 10,
  fontFamily: "none",
  fontSize: "none",
  fontWeight: "none",
  style: {
    mixBlendMode: "normal"
  },
  textAnchor: "none"
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M58.667 5.333v69.334l96 42.666 48-32z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M208 96v74.667l-149.333 80V85.333l48 26.667L64 240z"
}))));
export { SvgMsDynamicsIcon as ReactComponent };
export default __webpack_public_path__ + "ba4209a48b45d178b86ac086e2284a3d.svg";